// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { injectStripe, CardElement } from 'react-stripe-elements'
import axios from 'axios'

// Redux:
import { awardBadge } from 'actions/site'

class StripeForm extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			isProcessing: false,
			isProcessed: false,
			hasSuccess: false,
			hasError: false,
			hasErrorName: false,
			hasErrorEmail: false,
			name: '',
			email: '',
			message: ''
		}
	}

	handleChangeName = ( e ) => {
		this.setState({
			name: e.target.value
		})
	}

	handleChangeEmail = ( e ) => {
		this.setState({
			email: e.target.value
		})
	}

	handleChangeMessage = ( e ) => {
		this.setState({
			message: e.target.value
		})
	}

	handleAccept = () => {
		const { stripe, amount, recur, dispatch } = this.props
		const { name, email, message } = this.state

		if ( ! name || ! email ) {
			this.setState({
				hasError: true,
				hasErrorName: ! name,
				hasErrorEmail: ! email
			})

			setTimeout( () => {
				this.setState({
					hasError: false
				})
			}, 2700 )

			return
		}

		this.setState({
			isProcessing: true,
			hasError: false,
			hasErrorName: false,
			hasErrorEmail: false
		})

		stripe
			.createToken()
			.then( ( { token } ) => {
				axios({
						url: `${siteData.api_base_url}donate/?token=${token.id}&amount=${amount}&recurring=${recur}&name=${name}&email=${email}&message=${message}`,
						timeout: 20000,
						method: 'post',
						responseType: 'json'
					})
					.then( response => {
						this.showSuccess()

						setTimeout( () => {
							if ( recur ) {
								dispatch( awardBadge( 'donate_recurring' ) )
							} else {
								dispatch( awardBadge( 'donate' ) )
							}
						}, 2500 )
					})
					.catch( error => {
						this.showError()
					})
			})
			.catch( error => {
				this.showError()
			})
	}

	showSuccess = () => {
		this.setState({
			isProcessed: true,
			hasSuccess: true,
			hasError: false,
		})

		setTimeout( () => {
			this.props.handleClose()

			setTimeout( () => {
				this.setState({
					isOpen: false,
					isProcessing: false,
					isProcessed: false,
					hasSuccess: false,
				})
			}, 300 )
		}, 2000 )
	}

	showError = () => {
		this.setState({
			isProcessing: false,
			hasSuccess: false,
			hasError: true,
		})

		setTimeout( () => {
			this.setState({
				hasError: false
			})
		}, 2700 )
	}

	render() {
		const { handleAccpet, handleCancel, children, heading, acceptText, cancelText, recur } = this.props
		const { isProcessing, isProcessed, hasSuccess, hasError, hasErrorName, hasErrorEmail } = this.state
		const buttonText = isProcessing ? 'Processing...' : acceptText
		let className = '-inner'

		if ( hasSuccess ) {
			className += ' has-success'
		}

		if ( hasError ) {
			className += ' has-error'
		}

		const style = {
			base: {
				fontSize: '16px',
				fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
				fontSmoothing: 'antialiased',
				color: '#658188',
				'::placeholder': {
					color: '#8e8e8e'
				}
			},
			invalid: {
				color: '#d9534f',
				iconColor: '#fa755a'
			}
		}
		const errorClass = hasError ? '-error is-active' : '-error'

		return (
			<div className={ className }>
				<div className="-success">
					<i className="icon-gift"></i>

					<h5>Thanks!</h5>
				</div>

				<main>
					<h4>{ heading }</h4>

					<div className="-text">
						{ children }
					</div>

					<div className="-form">
						<div className={ hasErrorName ? '-input has-error' : '-input' }>
							<label htmlFor="donate-name">Name (required)</label>

							<input id="donate-name" type="text" onChange={ this.handleChangeName } />
						</div>

						<div className={ hasErrorEmail ? '-input has-error' : '-input' }>
							<label htmlFor="donate-email">Email (required)</label>

							<input id="donate-email" type="email" onChange={ this.handleChangeEmail } />
						</div>

						<div className="-input">
							<label htmlFor="donate-message">Message (optional)</label>

							<textarea id="donate-messag" cols="30" rows="3" onChange={ this.handleChangeMessage }></textarea>
						</div>

						<div className="-input">
							<label htmlFor="donate-card">Credit or debit card</label>

							<CardElement style={ style } />
						</div>
					</div>
				</main>

				<div className="-actions">
					<div className="button -cancel" onClick={ handleCancel }>{ cancelText }</div>

					<p className={ errorClass } disabled={ ! hasError }>Error: Please fill in all required fields.</p>

					<div className="button -confirm -accept" onClick={ this.handleAccept } disabled={ isProcessing }>
						{ buttonText }
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps )( injectStripe( StripeForm ) )
